/* global google, GMaps, MarkerClusterer */
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import qs from 'qs';

dayjs.extend(customParseFormat);
import HotelsSkeleton from '../../components/HotelsSkeleton/HotelsSkeleton';
import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

const MapSkeleton = () => {
  return (
    <div className="map-wrapper skeleton-shine" />
  );
};

class AppHotels extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      viewType: 'grid',
      loading: true,
      allHotels: [],
      allHotelLocations: [],
      searchNotice: '',
      heading: '',
      subHeading: '',
      hotelsLoaded: 0,
      mapHotelItemsShow: true,
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.location = '';
    this.locationLat = null;
    this.locationLng = null;
    this.startDate = '';
    this.endDate = '';
    this.brand = '';
    this.facilities = '';
    this.map = null;
    this.mapHotelMarkers = [];

    this.mapHotelItemsSectionRef = React.createRef();
    this.mapHotelItemsSectionObserver = null;

    const location = helpers.getParameterByName('location');
    if (location != null && location.length) {
      this.location = location;

      const startDateCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_START_DATE);
      const endDateCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_END_DATE);

      if (startDateCookie) {
        this.startDate = moment(new Date(startDateCookie)).format(constants.DATE_FORMAT_AUS);

        // Nested end date in start date
        if (endDateCookie) {
          this.endDate = moment(new Date(endDateCookie)).format(constants.DATE_FORMAT_AUS);
        }
      }
    }

    const brand = helpers.getParameterByName('brand');
    if (brand != null && brand.length) {
      this.brand = brand;
    }

    const facilities = helpers.getParameterByName('facilities');
    if (facilities != null && facilities.length) {
      this.facilities = facilities;
    }

    // Bind "this"
    this.handleViewTypeOnPageLoad = this.handleViewTypeOnPageLoad.bind(this);
    this.getCurrentLocation = this.getCurrentLocation.bind(this);
    this.loadSearchResults = this.loadSearchResults.bind(this);
    this.loadMoreSearchResults = this.loadMoreSearchResults.bind(this);
    this.handleHotelClick = this.handleHotelClick.bind(this);
    this.handleFlipCard = this.handleFlipCard.bind(this);
    this.handleUnflipCard = this.handleUnflipCard.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getMapMarker = this.getMapMarker.bind(this);
    this.loadMap = this.loadMap.bind(this);
    this.handleMapHotelItemsToggleClick = this.handleMapHotelItemsToggleClick.bind(this);
    this.handleMapHotelItemClick = this.handleMapHotelItemClick.bind(this);
    this.handleMapHotelItemsSlide = this.handleMapHotelItemsSlide.bind(this);
    this.redirectToSynxis = this.redirectToSynxis.bind(this);
    this.redirectToTelegraph = this.redirectToTelegraph.bind(this);
    this.redirectToInntopia = this.redirectToInntopia.bind(this);
    this.redirectToThredboRates = this.redirectToThredboRates.bind(this);
    this.redirectToThirdPartyBookingSites = this.redirectToThirdPartyBookingSites.bind(this);
    this.checkIfSynxisEnabled = this.checkIfSynxisEnabled.bind(this);
    this.checkIfTelegraphEnabled = this.checkIfTelegraphEnabled.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    // Load results on first page load
    if (this.location === 'Current Location') {
      this.getCurrentLocation(() => {
        this.loadSearchResults();
      });
    } else {
      this.loadSearchResults();
    }
    this.handleViewTypeOnPageLoad();

    // Reload results
    $(document).on(constants.EVENT_SUBMIT_CLICKED_SEARCH, (e, location, startDate, endDate) => {
      if (
        this.location !== location ||
        this.startDate !== startDate ||
        this.endDate !== endDate
      ) {
        this.location = location;
        this.startDate = startDate;
        this.endDate = endDate;

        if (location === 'Current Location') {
          this.getCurrentLocation(() => {
            this.loadSearchResults();
          });
        } else {
          this.loadSearchResults();
        }
      }
    });

    $(document).on(constants.EVENT_FACILITES_FILTER_CHANGED_SEARCH, (e, facilities) => {
      if (this.facilities !== facilities) {
        this.facilities = facilities;
        this.loadSearchResults();
      }
    });

    $(document).on(constants.EVENT_VIEW_TYPE_CHANGED, (e, viewType) => {
      this.setState({viewType});
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.loading ||
      (prevState.loading && !this.state.loading)
    ) {
      const searchNotice = $('.section-search-hotels .search-notice');
      if (searchNotice.length) {
        if (!this.state.loading && this.state.searchNotice.length > 0) {
          searchNotice.show();
          searchNotice.find('span').text(this.state.searchNotice);
        } else {
          searchNotice.hide();
          searchNotice.find('span').text('');
        }
      }

      const hotelsCount = $('.section-search-hotels .search-hotels-results-header .hotels-count');
      if (hotelsCount.length) {
        if (this.state.loading) {
          hotelsCount.text('');
        } else {
          hotelsCount.text(this.state.heading);
        }
      }

      const hotelsDescription = $('.section-search-hotels .search-hotels-results-header .hotels-description');
      if (hotelsDescription.length) {
        if (this.state.loading) {
          hotelsDescription.text('');
        } else {
          hotelsDescription.text(this.state.subHeading);
        }
      }
    }

    if (
      (prevState.loading && !this.state.loading && this.state.viewType === 'grid') ||
      (prevState.loadMoreLoading && !this.state.loadMoreLoading && this.state.viewType === 'grid') ||
      (!this.state.loading && prevState.viewType !== 'grid' && this.state.viewType === 'grid')
    ) {
      setTimeout(() => {
        // Equal height for elements
        helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-name.equal-height');
        helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-bookings.equal-height');

        // Booking form loaded
        $(document).trigger(constants.EVENT_BOOKING_FORM_LOADED);
      }, 200);
    }

    if (
      (prevState.loading && !this.state.loading && this.state.viewType === 'map') ||
      (prevState.loadMoreLoading && !this.state.loadMoreLoading && this.state.viewType === 'map') ||
      (!this.state.loading && prevState.viewType !== 'map' && this.state.viewType === 'map')
    ) {
      this.loadMap();
      this.handleMapHotelItemsSlide();
    }
  }

  componentWillUnmount() {
    if (this.mapHotelItemsSectionObserver) {
      this.mapHotelItemsSectionObserver.disconnect();
    }
  }

  checkIfTelegraphEnabled({
    hotelCode,
    hotelBrand,
  }) {
    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
      const location = BookingWidget['allBrandsLocations'][key];
      return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
    });

    if (!hotelKey) {
      return false;
    }

    const hotelData = BookingWidget['allBrandsLocations'][hotelKey];
    return hotelData['redirectToTelegraph'] || false;
  }

  redirectToTelegraph({
    hotelCode,
    hotelBrand,
    startDate,
    endDate,
    numGuests,
    dateFormat,
  }) {

    if (!this.checkIfTelegraphEnabled({
      hotelCode,
      hotelBrand,
    })) {
      return false;
    }

    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      DEFAULT_DATE_FORMAT,
      TELEGRAPH_CONSTANTS: {
        TELEGRAPH_URL,
        TELEGRAPH_HOTEL_ID,
        TELEGRAPH_DATE_DEFAULT_JS_FORMAT,
      },
    } = BookingWidget.constants;

    const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

    const arriveMoment = moment(startDate, bookingDateFormat);
    let arrival = startDate;

    if (arriveMoment.isValid()) {
      arrival = arriveMoment.format(TELEGRAPH_DATE_DEFAULT_JS_FORMAT);
    }

    const departMoment = moment(endDate, bookingDateFormat);
    let departure = endDate;

    if (departMoment.isValid()) {
      departure = departMoment.format(TELEGRAPH_DATE_DEFAULT_JS_FORMAT);
    }

    const rooms = numGuests.length;

    const params = {
      hotel: TELEGRAPH_HOTEL_ID,
      arrival,
      departure,
      rooms,
      codeType: 'promo',
      code: '',
    };

    numGuests.forEach((guest, idx) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      params[`adults[${idx + 1}]`] = isNaN(numAdults)? 0 : numAdults;
      params[`children[${idx + 1}]`] = isNaN(numChildren)? 0 : numChildren;
    });

    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (!value) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    window.open(`${TELEGRAPH_URL}/?${qsParams}`, '_blank');

    return true;
  }

  redirectToThredboRates({
    hotel,
    numGuests,
    startDate,
    endDate,
    dateFormat,
  }) {
    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      THREDBO_CONSTANTS: {
        RATES_URL,
        BRAND: THREDBO_BRAND,
        HOTEL_CODE: THREDBO_HOTEL_CODE,
      },
    } = BookingWidget.constants;

    if (!hotel['redirectToThredboRates']) {
      return false;
    }

    const rooms = numGuests.length;
    const adultsPerRoom = [];
    const kidsPerRoom = [];
    const childAgesPerRoom = [];

    numGuests.forEach((guest) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      const adultCount = isNaN(numAdults) ? 0 : Number(numAdults);
      const kidCount = isNaN(numChildren) ? 0 : Number(numChildren);

      adultsPerRoom.push(adultCount);
      kidsPerRoom.push(kidCount);
      childAgesPerRoom.push(kidCount > 0 ? Array(kidCount).fill(0).join(',') : '');
    });

    const adults = adultsPerRoom.join(',');
    const kids = kidsPerRoom.join(',');
    const childAges = childAgesPerRoom.filter((ages) => ages !== '').join('|');

    const checkinDayjs = dayjs(startDate, dateFormat);
    const checkin = checkinDayjs.isValid() ? checkinDayjs.format('YYYY-MM-DD') : null;
    const checkoutDayjs = dayjs(endDate, dateFormat);
    const checkout = checkoutDayjs.isValid() ? checkoutDayjs.format('YYYY-MM-DD') : null;

    const params = {
      brand: THREDBO_BRAND,
      hotelCode: THREDBO_HOTEL_CODE,
      rooms,
      adults,
      kids,
      childAges,
      checkin,
      checkout,
    };

    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (value === '' || value === null || value === undefined) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    const [ratesBaseUrl, ratesHash] = RATES_URL.split('#');
    const ratesUrl = ratesHash ? `${ratesBaseUrl}?${qsParams}/#${ratesHash}` : `${ratesBaseUrl}?${qsParams}`;
    window.open(ratesUrl, '_blank');

    return true;
  }

  redirectToInntopia({
    hotelCode,
    startDate,
    endDate,
    numGuests,
    dateFormat,
  }) {

    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      DEFAULT_DATE_FORMAT,
      INNTOPIA_CONSTANTS: {
        INNTOPIA_URL,
        INNTOPIA_SUPPLIER_ID,
        INNTOPIA_DATE_DEFAULT_JS_FORMAT,
        INNTOPIA_HOTEL_CODE,
      },
    } = BookingWidget.constants;

    if (hotelCode !== INNTOPIA_HOTEL_CODE) {
      return false;
    }

    const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

    const arriveMoment = moment(startDate, bookingDateFormat);
    let arrival = startDate;

    if (arriveMoment.isValid()) {
      arrival = arriveMoment.format(INNTOPIA_DATE_DEFAULT_JS_FORMAT);
    }

    const departMoment = moment(endDate, bookingDateFormat);
    let departure = endDate;

    if (departMoment.isValid()) {
      departure = departMoment.format(INNTOPIA_DATE_DEFAULT_JS_FORMAT);
    }

    const params = {
      supplierid: INNTOPIA_SUPPLIER_ID,
      arrivaldate: arrival,
      departuredate: departure,
    };

    numGuests.forEach((guest) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      params['adultcount']    = isNaN(numAdults)? 0 : numAdults;
      params['childCount']    = isNaN(numChildren)? 0 : numChildren;
    });

    params['childagearray'] = '#Availability';

    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (!value) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    window.open(`${INNTOPIA_URL}/?${qsParams}`, '_blank');

    return true;
  }

  checkIfSynxisEnabled({
    hotelCode,
    hotelBrand,
  }) {
    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      SYNXIS_CONSTANTS: {
        SYNXIS_BRAND_CODES,
      },
    } = BookingWidget.constants;

    const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
      const location = BookingWidget['allBrandsLocations'][key];
      return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
    });

    if (!hotelKey) {
      return false;
    }

    const hotelData = BookingWidget['allBrandsLocations'][hotelKey];
    const synxisSettings = hotelData['synxisSettings'];
    const brand = hotelData['brand'];
    const ratesApiSource = hotelData['ratesApiSource'];

    if (!synxisSettings) {
      return false;
    }

    const synxisBrandCode = SYNXIS_BRAND_CODES[brand];

    if (!synxisBrandCode) {
      return false;
    }

    if (ratesApiSource !== 'ireckonu_api') {
      return false;
    }

    if (
      !synxisSettings.enableSynxisHotel
      || !synxisSettings.synxisChainId
    ) {
      return false;
    }

    return true;
  }

  redirectToSynxis({
    hotelCode,
    hotelBrand,
    startDate,
    endDate,
    numGuests,
    dateFormat,
  }) {
    if (!this.checkIfSynxisEnabled({
      hotelCode,
      hotelBrand,
    })) {
      return false;
    }

    const { BookingWidget } = window;

    const {
      DEFAULT_DATE_FORMAT,
      SYNXIS_CONSTANTS: {
        SYNXIS_URL,
        SYNXIS_DATE_DEFAULT_JS_FORMAT,
        SYNXIS_BRAND_CODES,
      },
    } = BookingWidget.constants;

    const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
      const location = BookingWidget['allBrandsLocations'][key];
      return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
    });

    const hotelData = BookingWidget['allBrandsLocations'][hotelKey];
    const synxisSettings = hotelData['synxisSettings'];
    const brand = hotelData['brand'];

    const synxisBrandCode = SYNXIS_BRAND_CODES[brand];

    const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

    const arriveMoment = moment(startDate, bookingDateFormat);
    let arrive = startDate;

    if (arriveMoment.isValid()) {
      arrive = arriveMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
    }

    const departMoment = moment(endDate, bookingDateFormat);
    let depart = endDate;

    if (departMoment.isValid()) {
      depart = departMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
    }

    const adultsCounts = [];
    const childrenCounts = [];

    numGuests.forEach((guest) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      adultsCounts.push(isNaN(numAdults)? 0 : numAdults);
      childrenCounts.push(isNaN(numChildren)? 0 : numChildren);
    });

    const adult = adultsCounts.join(',');
    const child = childrenCounts.join(',');

    const rooms = numGuests.length;

    const params = {
      Hotel: synxisSettings.synxisHotelId,
      Chain: synxisSettings.synxisChainId,
      theme: synxisBrandCode,
      config: synxisBrandCode,
      arrive,
      depart,
      rooms,
      adult,
      child,
    };


    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (!value) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    window.open(`${SYNXIS_URL}/?${qsParams}`, '_blank');

    return true;
  }

  handleViewTypeOnPageLoad() {
    const view = helpers.getParameterByName('view');
    if (
      view != null &&
      view.length &&
      (view === 'grid' || view === 'map')
    ) {
      this.setState({viewType: view});
    }
  }

  getCurrentLocation(callback) {
    if (!navigator.geolocation) {
      // Geolocation not supported
      this.locationLat = null;
      this.locationLng = null;

      if (typeof callback === 'function') {
        callback();
      }

      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.locationLat = position.coords.latitude;
        this.locationLng = position.coords.longitude;

        if (typeof callback === 'function') {
          callback();
        }
      },
      () => {
        // On error
        this.locationLat = null;
        this.locationLng = null;

        if (typeof callback === 'function') {
          callback();
        }
      }
    );
  }

  loadSearchResults() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState({
      loading: true,
      allHotels: [],
      allHotelLocations: [],
      searchNotice: '',
      heading: '',
      subHeading: '',
      hotelsLoaded: 0,
      loadMoreLoading: false,
      loadedAll: false,
    });

    // Params
    const data = {
      'action': constants.ACTION_GET_HOTELS,
      'location': this.location,
      'locationLat': this.locationLat,
      'locationLng': this.locationLng,
      'startDate': this.startDate,
      'endDate': this.endDate,
      'brand': this.brand,
      'facilities': this.facilities,
      'offset': 0,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const searchNotice = response.data['search_notice'];
          const hotelsCount = response.data['properties_count'];
          const searchedLocation = response.data['searched_location'];
          const hotels = [...response.data['properties_groups']];
          const hotelLocations = [...response.data['properties_locations']];

          if (0 === hotelsCount) {
            this.setState({
              searchNotice: '',
              heading: 'Oops',
              subHeading: 'No hotels found',
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          } else {
            let numHotelsLoaded = 0;
            let dataLayerHotelCodes = [];

            for (let i = 0; i < hotels.length; i++) {
              let hotelBrand = hotels[i];

              if (hotelBrand['hotels'].length > 0) {
                numHotelsLoaded += hotelBrand['hotels'].length;

                dataLayerHotelCodes = dataLayerHotelCodes.concat(hotelBrand['hotels'].map((hotel) => {
                  return hotel['hotelCode'];
                }));
              }
            }

            // Push search event to dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'search',
              'hotelCodes': dataLayerHotelCodes.join(','),
              'startDate': '',
              'endDate': '',
            });

            this.setState({
              loading: false,
              searchedLocation: searchedLocation,
              allHotels: [...hotels],
              allHotelLocations: [...hotelLocations],
              searchNotice: searchNotice,
              heading: response.data['heading'],
              subHeading: response.data['sub_heading'],
              hotelsLoaded: numHotelsLoaded,
              loadMoreLoading: false,
              loadedAll: hotelsCount === numHotelsLoaded,
            });
          }
        } else {
          this.setState({
            searchNotice: '',
            heading: 'Oops',
            subHeading: 'Something went wrong.',
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreSearchResults() {
    const {
      allHotels,
      hotelsLoaded,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_HOTELS,
        'location': this.location,
        'locationLat': this.locationLat,
        'locationLng': this.locationLng,
        'startDate': this.startDate,
        'endDate': this.endDate,
        'brand': this.brand,
        'facilities': this.facilities,
        'offset': hotelsLoaded,
      };

      // Send request
      axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const hotelsCount = response.data['properties_count'];
            const hotels = [...response.data['properties_groups']];
            let allHotelsArr = [...allHotels];
            let numHotelsLoaded = hotelsLoaded;

            for (let i = 0; i < hotels.length; i++) {
              let hotelBrand = hotels[i];

              let hotelBrandIndex = allHotelsArr.findIndex((singleHotelBrand) => singleHotelBrand['brand_name'] === hotelBrand['brand_name']);

              if (hotelBrandIndex > -1) {
                allHotelsArr[hotelBrandIndex]['hotels'] = [
                  ...allHotelsArr[hotelBrandIndex]['hotels'],
                  ...hotelBrand['hotels'],
                ];
              } else {
                allHotelsArr = [
                  ...allHotelsArr,
                  ...hotelBrand,
                ];
              }

              if (hotelBrand['hotels'].length > 0) {
                numHotelsLoaded = numHotelsLoaded + hotelBrand['hotels'].length;
              }
            }

            this.setState({
              loading: false,
              allHotels: allHotelsArr,
              hotelsLoaded: numHotelsLoaded,
              loadMoreLoading: false,
              loadedAll: hotelsCount === numHotelsLoaded,
            });
          } else {
            this.setState({
              searchNotice: '',
              heading: 'Oops',
              subHeading: 'Something went wrong.',
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  redirectToThirdPartyBookingSites({
    hotel,
    startDate,
    endDate,
    dateFormat,
  }) {

    if (startDate && endDate) {
      const numGuests = [{
        numAdults: 2,
        numChildren: 0,
      }];

      // Redirect to Thredbo Rates
      if (this.redirectToThredboRates({
        hotel,
        numGuests,
        startDate,
        endDate,
        dateFormat,
      })) {
        return true;
      }

      // Redirect to Inntopia
      if (this.redirectToInntopia({
        hotelCode: hotel['hotelCode'],
        startDate,
        endDate,
        numGuests,
        dateFormat,
      })) {
        return true;
      }

      if (this.redirectToSynxis({
        hotelCode: hotel['hotelCode'],
        hotelBrand: hotel['brand'],
        startDate,
        endDate,
        numGuests,
        dateFormat,
      })) {
        return true;
      }

      if (this.redirectToTelegraph({
        hotelCode: hotel['hotelCode'],
        hotelBrand: hotel['brand'],
        startDate,
        endDate,
        numGuests,
        dateFormat,
      })) {
        return true;
      }
    }

    return false;
  }

  handleHotelClick(e, name, brand, link) {
    e.preventDefault();

    // Save to recent viewed
    if (name.length) {
      let recentViewed = JSON.parse(helpers.docCookies.getItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_VIEWED)) || [];
      if (null !== recentViewed) {
        const data = {
          name: name,
          brand: brand,
        };

        // Avoid duplicated saved recent viewed
        recentViewed = recentViewed.filter((item) => item['name'] !== data['name']);
        recentViewed.unshift(data);

        // Save last 3 searches to cookie
        helpers.docCookies.setItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_VIEWED, JSON.stringify(recentViewed.slice(0, 3)), 30 * 86400, '/');
      }
    }

    window.location.href = link;
  }

  validateNRMA() {
    if (!window.NRMA_Membership) {
      return true;
    }

    if (typeof window.NRMA_Membership.isNrmaLandingPage !== 'function') {
      return true;
    }

    if (!window.NRMA_Membership.isNrmaLandingPage()) {
      return true;
    }

    if (typeof window.NRMA_Membership.validate !== 'function') {
      return true;
    }

    return window.NRMA_Membership.validate();
  }

  getNRMAToken() {
    if (!window.NRMA_Membership) {
      return null;
    }

    if (typeof window.NRMA_Membership.getToken !== 'function') {
      return null;
    }

    return window.NRMA_Membership.getToken();
  }

  handleFlipCard(e, hotel) {
    e.preventDefault();

    if (!this.validateNRMA()) {
      return;
    }

    const searchAccommodationFormWrapper = $('.search-accommodations-form-wrapper');
    const form = searchAccommodationFormWrapper.find('form');
    const startDateVal = form.find('[name="startDate"]').val();
    const endDateVal = form.find('[name="endDate"]').val();

    const startDate = moment(new Date(startDateVal)).format(constants.DATE_FORMAT_AUS);
    const endDate = moment(new Date(endDateVal)).format(constants.DATE_FORMAT_AUS);

    if (startDateVal !== '' && endDateVal !== '') {
      if (this.redirectToThirdPartyBookingSites({
        hotel,
        startDate,
        endDate,
        dateFormat: constants.DATE_FORMAT_AUS,
      })) {
        return;
      }

      let submitUrl = '';
      const params = {
        hotelCode: hotel['hotelCode'],
        startDate,
        endDate,
        numRooms: 1,
        numGuests: [{
          numAdults: 2,
          numChildren: 0,
        }],
      };

      if ('bookingTarget' in hotel) {
        params.channelCode = hotel['bookingTarget']['channel_code'];
      } else {
        params.channelCode = window.Rydges['defaultChannelCode'];
      }

      if ('bookingTarget' in hotel && (hotel['bookingTarget']['domain'] !== 'rydges.com')) {
        const nrmaToken = this.getNRMAToken(); // No need to url encode since jQuery param takes care of that
        submitUrl = hotel['bookingTarget']['rates_page'] + '?' + $.param({
          ...params,
          nrmaToken,
        });
      } else {
        helpers.docCookies.setItem('rsd_ba_b', JSON.stringify(params), 3600, '/', 'rydges.com');
        submitUrl = window.Rydges['ratesPageUrl'];
      }

      if (submitUrl.length > 0) {
        window.location = submitUrl;
      }
    } else {
      const resultsWrapper = $('#search-hotels-results-wrapper');
      const thisFlipCard = $(e.target).closest('.hotel-flip-card');

      resultsWrapper.find('.hotel-flip-card .hotel-flip-card-wrapper').removeClass('wrapper-flipped');
      thisFlipCard.closest('.hotel-flip-card-wrapper').addClass('wrapper-flipped');
      resultsWrapper.find('.hotel-flip-card .flip-card-wrapper').removeClass('card-flipped');
      thisFlipCard.find('.flip-card-wrapper').addClass('card-flipped');
    }

    return false;
  }

  handleUnflipCard(e) {
    e.preventDefault();

    const thisFlipCard = $(e.target).closest('.hotel-flip-card');

    thisFlipCard.closest('.hotel-flip-card-wrapper').removeClass('wrapper-flipped');
    thisFlipCard.find('.flip-card-wrapper').removeClass('card-flipped');

    return false;
  }

  handleSubmit(e, hotel) {
    e.preventDefault();

    const form = $(e.target);
    const dayUseInput = form.find('[name="dayUse"]');
    const startDateVal = form.find('[name="startDate"]').val();
    const endDateVal = form.find('[name="endDate"]').val();
    if (startDateVal === '' || endDateVal === '') {
      return form.find('.date-validator').show();
    } else {
      form.find('.date-validator').hide();
    }

    const startDate = moment(new Date(startDateVal)).format(constants.DATE_FORMAT_AUS);
    const endDate = moment(new Date(endDateVal)).format(constants.DATE_FORMAT_AUS);

    if (this.redirectToThirdPartyBookingSites({
      hotel,
      startDate,
      endDate,
      dateFormat: constants.DATE_FORMAT_AUS,
    })) {
      return;
    }

    let submitUrl = '';
    const params = {
      hotelCode: hotel['hotelCode'],
      startDate,
      endDate,
      numRooms: 1,
      numGuests: [{
        numAdults: 2,
        numChildren: 0,
      }],
    };

    if (hotel['enableDayUse'] && dayUseInput.length) {
      if (dayUseInput.is(':checked')) {
        params.dayUse = true;
        params.blockCode = hotel['dayUseBlockCode'];
      } else {
        params.dayUse = false;
        params.blockCode = '';
      }
    }

    if ('bookingTarget' in hotel) {
      params.channelCode = hotel['bookingTarget']['channel_code'];
    } else {
      params.channelCode = window.Rydges['defaultChannelCode'];
    }

    if ('bookingTarget' in hotel && (hotel['bookingTarget']['domain'] !== 'rydges.com')) {
      const nrmaToken = this.getNRMAToken(); // No need to url encode since jQuery param takes care of that
      submitUrl = hotel['bookingTarget']['rates_page'] + '?' + $.param({
        ...params,
        nrmaToken,
      });
    } else {
      helpers.docCookies.setItem('rsd_ba_b', JSON.stringify(params), 3600, '/', 'rydges.com');
      submitUrl = window.Rydges['ratesPageUrl'];
    }

    if (submitUrl.length > 0) {
      // Add loading on button
      form.find('button[type="submit"]').prop('disabled', true);
      form.find('.spinner-loader').removeClass('hidden');

      window.location = submitUrl;
    }
  }

  getMapMarker(type) {
    const {
      mapMarkers,
    } = this.props;
    const mapMarkersFallback = {
      default: window.Rydges.assetsPath + 'images/map-markers/hotels.svg',
      active: window.Rydges.assetsPath + 'images/map-markers/hotels-red.svg',
      searched_location: window.Rydges.assetsPath + 'images/map-markers/hotels-star.svg',
      clustered_locations: window.Rydges.assetsPath + 'images/map-markers/blank.svg',
    };
    const urlFromProps = (mapMarkers && mapMarkers[type]) ? mapMarkers[type] : null;
    const url = urlFromProps && urlFromProps.trim() !== '' ? urlFromProps : mapMarkersFallback[type];
    const isFallback = url === mapMarkersFallback[type];
    const applySizeLogic = (type === 'default' || type === 'active');

    return {
      url,
      scaledSize: applySizeLogic
        ? (isFallback ? new google.maps.Size(32, 32) : new google.maps.Size(20, 20))
        : new google.maps.Size(32, 32),
    };
  }

  loadMap() {
    if ($('#hotels-map-wrapper').length) {
      const {
        searchedLocation,
        allHotelLocations,
      } = this.state;

      if (allHotelLocations.length > 0) {
        const self = this;

        // Setup first item on map
        this.map = new GMaps({
          div: '#hotels-map-wrapper',
          scrollwheel: false,
          center: new google.maps.LatLng(allHotelLocations[0]['address']['lat'], allHotelLocations[0]['address']['lng']),
          zoom: 15,
          zoomControl: true,
          zoomControlOpt: {
            style: 'SMALL',
            position: google.maps.ControlPosition.RIGHT_BOTTOM,
          },
          panControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          overviewMapControl: false,
          rotateControl: false,
          scaleControl: false,
          fullscreenControl: false,
          markerClusterer: function(map) {
            return new MarkerClusterer(map, null, {
              styles: [
                {
                  url: self.getMapMarker('clustered_locations').url,
                  textColor: 'white',
                  textSize: 20,
                  height: 62,
                  width: 62,
                },
              ],
            });
          },
        });

        this.mapHotelMarkers = [];
        const bounds = [];

        if (searchedLocation && Object.keys(searchedLocation).length > 0) {
          bounds.push(new google.maps.LatLng(searchedLocation['lat'], searchedLocation['lng']));

          this.map.addMarker({
            lat: searchedLocation['lat'],
            lng: searchedLocation['lng'],
            icon: this.getMapMarker('searched_location'),
          });
        }

        let activeMarker = null;
        const mapMarkerInfoWindowTemplate = $('#hotels-map-marker-info-window').html();

        for (let i = 0; i < allHotelLocations.length; i++) {
          if (Object.keys(allHotelLocations[i]['address']).length > 0) {
            const title = allHotelLocations[i]['title'];
            const lat = allHotelLocations[i]['address']['lat'];
            const lng = allHotelLocations[i]['address']['lng'];
            const link = allHotelLocations[i]['link'];

            bounds.push(new google.maps.LatLng(lat, lng));

            const marker = this.map.addMarker({
              lat: lat,
              lng: lng,
              title: title,
              icon: self.getMapMarker('default'),
              infoWindow: {
                content: helpers.transformMapMarkerInfoWindow({
                  title,
                  hasImage: allHotelLocations[i]['image'].length > 0 ? 'show' : '',
                  image: allHotelLocations[i]['image'],
                  hasRibbonLabel: allHotelLocations[i]['ribbon_label'].length > 0 ? 'show' : '',
                  ribbonLabel: allHotelLocations[i]['ribbon_label'],
                  address: allHotelLocations[i]['address']['address'],
                  hasLocationDistance: allHotelLocations[i]['location_distance'].length > 0 ? 'show' : '',
                  locationDistance: allHotelLocations[i]['location_distance'],
                  bookLink: allHotelLocations[i]['book_link'],
                  link,
                }, mapMarkerInfoWindowTemplate),
                pixelOffset: new google.maps.Size(0, -10),
              },
              click() {
                // Change pin icon
                if (activeMarker) {
                  activeMarker.setIcon(self.getMapMarker('default'));
                }
                this.setIcon(self.getMapMarker('active'));
                activeMarker = this;

                setTimeout(() => {
                  // Remove info window arrow
                  const gmStyleIw = $('.gm-style-iw');
                  const gmArrow = gmStyleIw.prev().find('div').eq(2);
                  gmArrow.parent().find('div').eq(0).hide();
                  gmArrow.hide();
                }, 10);
              },
            });

            marker._hotelId = allHotelLocations[i]['id'];
            this.mapHotelMarkers.push(marker);
          }
        }

        if (allHotelLocations.length > 1) {
          this.map.fitLatLngBounds(bounds);
        }
      }
    }
  }

  handleMapHotelItemsToggleClick(e) {
    e.preventDefault();

    this.setState((prevState) => ({
      mapHotelItemsShow: !prevState.mapHotelItemsShow,
    }));
  }

  handleMapHotelItemClick(e, id) {
    e.preventDefault();

    const marker = this.mapHotelMarkers.find((m) => m._hotelId === id);
    if (!marker) {
      return;
    }

    const map = this.map.map;
    const projection = map.getProjection();
    if (!projection) {
      return;
    }

    map.setZoom(17);
    const zoom = map.getZoom();
    const scale = Math.pow(2, zoom);
    const worldPoint = projection.fromLatLngToPoint(marker.getPosition());
    let pixelOffsetX = 0;

    if ($(window).width() >= 768) {
      const sidebarWidth = 450;
      const offsetX = sidebarWidth / 2;
      pixelOffsetX = offsetX / scale;
    }

    const newCenterPoint = new google.maps.Point(
      worldPoint.x - pixelOffsetX, // shift right
      worldPoint.y
    );
    const newLatLng = projection.fromPointToLatLng(newCenterPoint);

    this.mapHotelMarkers.forEach((m) => {
      if (m.infoWindow) {
        m.infoWindow.close();
      }
    });
    map.setZoom(17);
    map.panTo(newLatLng);
    marker.infoWindow.open(map, marker);
    google.maps.event.trigger(marker, 'click');
  }

  handleMapHotelItemsSlide() {
    const container = this.mapHotelItemsSectionRef && this.mapHotelItemsSectionRef.current;

    if (this.mapHotelItemsSectionObserver) {
      this.mapHotelItemsSectionObserver.disconnect();
      this.mapHotelItemsSectionObserver = null;
    }

    if ($(window).width() < 767 && container) {
      const slides = container.querySelectorAll('.map-hotel-item-wrapper');

      this.mapHotelItemsSectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const dataId = entry.target.getAttribute('data-id');
              this.handleMapHotelItemClick({preventDefault: () => {}}, parseInt(dataId));
            }
          });
        },
        {
          root: container,
          threshold: 0.5,
        }
      );

      slides.forEach((slide) => this.mapHotelItemsSectionObserver.observe(slide));
    }
  }

  render() {
    const {
      corporateDiscountText,
      flipOnHotelNameClick,
    } = this.props;
    const {
      viewType,
      loading,
      allHotels,
      allHotelLocations,
      mapHotelItemsShow,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        <div className="container">
          {
            viewType === 'grid' && (
              <React.Fragment>
                <div className="hotel-result-container pt-4">
                  {!loading && allHotels.length > 0 && (
                    <div className="hotel-network-wrapper">
                      {
                        allHotels.map((hotelBrand, i) => {
                          return (
                            hotelBrand['hotels'].length > 0 && (
                              <React.Fragment key={i}>
                                <h3 className="mb-4">{hotelBrand['hotels_count']} {hotelBrand['brand_name']} {(1 === hotelBrand['hotels_count'] ? ' hotel' : ' hotels')}</h3>
                                <div className="hotel-wrapper mb-3">
                                  {
                                    hotelBrand['hotels'].map((hotel, j) => {
                                      const hotelCode = hotel['hotelCode'];
                                      const hotelBrand = hotel['brand'];

                                      const linkProps = {};

                                      if (this.checkIfTelegraphEnabled({
                                        hotelCode,
                                        hotelBrand,
                                      }) || this.checkIfSynxisEnabled({
                                        hotelCode,
                                        hotelBrand,
                                      })) {
                                        linkProps.target = '_blank';
                                        linkProps.rel = 'noopener noreferrer';
                                      }

                                      const featuredImage = hotel['featuredImage'].length > 0 ? hotel['featuredImage'] : 'https://via.placeholder.com/465x330';
                                      return (
                                        <div className="single-hotel hotel-flip-card-wrapper" key={j}>
                                          <div className="hotel-flip-card">
                                            <div className={'flip-card-wrapper' + (parseInt(helpers.IsIEBrowser()) <= 11 ? ' use-opacity' : '')}>
                                              <div className="card-front">
                                                <div className="single-hotel-wrapper">
                                                  <div className="preview-images bg-center d-block"
                                                       style={{backgroundImage: `url(${featuredImage})`}}
                                                       onClick={(e) => this.handleFlipCard(e, hotel)}
                                                       {...linkProps}
                                                  >
                                                    {
                                                      'isNew' in hotel && hotel['isNew'] && (
                                                        <span className="item-tag">new</span>
                                                      )
                                                    }
                                                  </div>
                                                  <div className="hotel-info">
                                                    {
                                                      corporateDiscountText.length > 0 && (
                                                        <div className="corporate-discount-text-wrapper">
                                                          <div className="corporate-discount-text">
                                                            {corporateDiscountText}
                                                          </div>
                                                        </div>
                                                      )
                                                    }
                                                    <div className={`hotel-name equal-height d-flex flex-column align-items-start ${(!hotel['noBookings'] && hotel['ctaLabel'].length === 0 && hotel['discountText'].length === 0) ? 'mb-3' : ''}`}>
                                                      {
                                                        flipOnHotelNameClick
                                                          ? (
                                                            <React.Fragment>
                                                              {
                                                                hotel['hotelName'].length > 0 && (
                                                                  <a href={hotel['homeUrl']}
                                                                     className="name"
                                                                     onClick={(e) => this.handleFlipCard(e, hotel)}
                                                                  >{hotel['hotelName']}</a>
                                                                )
                                                              }
                                                            </React.Fragment>
                                                          ) : (
                                                            <React.Fragment>
                                                              {
                                                                hotel['hotelName'].length > 0 && (
                                                                  <a href={hotel['homeUrl']}
                                                                     className="name"
                                                                     onClick={(e) => this.handleHotelClick(e, hotel['hotelName'], hotel['brand'], hotel['homeUrl'])}
                                                                  >{hotel['hotelName']}</a>
                                                                )
                                                              }
                                                            </React.Fragment>
                                                          )

                                                      }
                                                      {
                                                        hotel['locationDistance'].length > 0 && (
                                                          <div className="distance d-flex align-items-center">
                                                            <img src={window.Rydges['assetsPath'] + 'images/icons/pin-2.svg'}
                                                                 className="img-fluid mr-2"
                                                                 width="12"
                                                            />
                                                            {hotel['locationDistance']}
                                                          </div>
                                                        )
                                                      }
                                                    </div>
                                                    <div className="hotel-bookings equal-height">
                                                      {
                                                        hotel['ctaLabel'].length > 0 && (
                                                          <div className={`price ${(!hotel['noBookings'] && hotel['discountText'].length === 0) ? 'mb-3' : ''}`}>
                                                            {/*
                                                            {
                                                              null !== hotel['minimumRate'] &&
                                                              hotel['minimumRate'].length > 0 &&
                                                              hotel['minimumRate'] > 0
                                                                ? 'From ' + helpers.getFormattedCurrency(hotel['currencyCode']) + hotel['minimumRate'] + ' | Night'
                                                                : 'Best rate guaranteed'
                                                            }
                                                            */}
                                                            {hotel['ctaLabel']}
                                                          </div>
                                                        )
                                                      }
                                                      {
                                                        !hotel['noBookings'] && (
                                                          <React.Fragment>
                                                            {
                                                              hotel['discountText'].length > 0 && (
                                                                <div className="mb-3">
                                                                  <a href="#" className="discount evtstays-not-logged-in-elements login-join-trigger">{hotel['discountText']}</a>
                                                                  <div className="discount evtstays-logged-in-elements">{hotel['discountText']}</div>
                                                                </div>
                                                              )
                                                            }
                                                            <div className="btn btn-red btn-flip text-uppercase"
                                                                 onClick={(e) => this.handleFlipCard(e, hotel)}
                                                            >
                                                              Book Now
                                                            </div>
                                                          </React.Fragment>
                                                        )
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="card-back p-3">
                                                <div className="close-icon btn-unflip" onClick={this.handleUnflipCard}>
                                                  <img className="img-fluid"
                                                       src={window.Rydges['assetsPath'] + 'images/icons/times.svg'}
                                                       width={12}
                                                  />
                                                </div>
                                                <div className="card-form hotel-booking-form-container mt-0">
                                                  {
                                                    hotel['hotelName'].length > 0 && (
                                                      <div className="card-book-title mb-2">
                                                        Book now at<br />{hotel['hotelName']}
                                                      </div>
                                                    )
                                                  }
                                                  <form className="hotel-booking-form generic-booking-form position-relative mt-5" onSubmit={(e) => this.handleSubmit(e, hotel)}>
                                                    <div className="inner-content">
                                                      {
                                                        hotel['enableDayUse'] && (
                                                          <div className="mb-4p5 dayuse-wrapper">
                                                            <label className="switch-wrapper d-inline-flex align-items-center mb-0">
                                                              <input className="switch-input" name="dayUse" type="checkbox" />
                                                              <span className="switch-toggle d-inline-block mr-3 position-relative" />
                                                              <span>Book for day use</span>
                                                            </label>
                                                            {
                                                              hotel['dayUseMessage'].length > 0 && (
                                                                <p className="d-block small dayuse-message">
                                                                  {hotel['dayUseMessage']}
                                                                </p>
                                                              )
                                                            }
                                                          </div>
                                                        )
                                                      }
                                                      <div className="booking-input-wrapper booking-dates-wrapper mb-4">
                                                        <div className="d-flex justify-content-between align-items-end w-100 position-relative">
                                                          <input className="booking-daterange-picker d-none d-sm-block"
                                                                 type="text"
                                                                 autoComplete="off"
                                                                 defaultValue=""
                                                                 data-drp-min={hotel['minDate']}
                                                                 data-drp-max={hotel['maxDate']}
                                                                 data-open-side={((j % 4 === 0) ? 'right' : 'left')}
                                                                 readOnly
                                                          />
                                                          <input className="booking-daterange-picker mobile-booking-daterange-picker d-block d-sm-none"
                                                                 type="text"
                                                                 autoComplete="off"
                                                                 defaultValue=""
                                                                 data-drp-min={hotel['minDate']}
                                                                 data-drp-max={hotel['maxDate']}
                                                                 readOnly
                                                          />
                                                          <label className="w-100">
                                                            Arrive
                                                            <input className="w-100 check-in"
                                                                   type="text"
                                                                   readOnly
                                                                   name="checkin"
                                                                   placeholder=""
                                                            />
                                                            <input type="hidden" name="startDate" />
                                                          </label>
                                                          <span className="px-3 pb-1 mb-2 hidden-on-dayuse">to</span>
                                                          <label className="w-100 hidden-on-dayuse">
                                                            Depart
                                                            <input className="w-100 check-out"
                                                                   type="text"
                                                                   readOnly
                                                                   name="checkout"
                                                                   placeholder=""
                                                            />
                                                            <input type="hidden" name="endDate" />
                                                          </label>
                                                        </div>
                                                        <div className="date-validator">
                                                          You need to enter the dates of your stay
                                                        </div>
                                                      </div>
                                                      <div className="d-flex align-items-center">
                                                        <button type="submit"
                                                                className="btn btn-red-outline text-uppercase d-block w-100"
                                                        >
                                                          Book Now
                                                        </button>
                                                        <div className="spinner-loader hidden ml-3 flex-shrink-0"></div>
                                                      </div>
                                                    </div>
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })
                                  }
                                </div>
                              </React.Fragment>
                            )
                          );
                        })
                      }
                    </div>
                  )}

                  {(loading || loadMoreLoading) && (
                    <HotelsSkeleton/>
                  )}
                </div>
                <div className="text-center">
                  <button className="btn btn-red btn-lg btn-border-red btn-load-more mt-3 px-5" disabled={loading || loadMoreLoading || loadedAll} onClick={this.loadMoreSearchResults}>
                    {!loadedAll ? 'Load More' : 'That\'s All'}
                  </button>
                </div>
              </React.Fragment>
            )
          }
        </div>
        <div className="container map-container">
          {
            viewType === 'map' && (
              <React.Fragment>
                {
                  !loading && !loadMoreLoading && (
                    <div className="map-container-inner">
                      {
                        allHotelLocations.length > 0 && (
                          <div className={`map-hotel-items-container ${mapHotelItemsShow ? 'show' : ''}`}>
                            <img src={window.Rydges['assetsPath'] + 'images/icons/right-double-chevron-circle.svg'}
                                 className="map-hotel-items-toggle"
                                 onClick={this.handleMapHotelItemsToggleClick}
                            />
                            <div ref={this.mapHotelItemsSectionRef} className="map-hotel-items-wrapper">
                              {
                                allHotelLocations.map((hotel, i) => {
                                  return (
                                    <div key={i} className="map-hotel-item-wrapper" data-id={hotel['id']}>
                                      <div className="map-hotel-item" onClick={(e) => this.handleMapHotelItemClick(e, hotel['id'])}>
                                        {
                                          hotel['image'].length > 0 && (
                                            <div className="map-hotel-item-image-container">
                                              {
                                                hotel['ribbon_label'].length > 0 && (
                                                  <div className="ribbon small">
                                                    <div className="ribbon-inner">
                                                      {hotel['ribbon_label']}
                                                    </div>
                                                  </div>
                                                )
                                              }
                                              <div className="map-hotel-item-image-wrapper">
                                                <img className="map-hotel-item-image" src={hotel['image']} alt="" />
                                              </div>
                                            </div>
                                          )
                                        }
                                        <div className="map-hotel-item-content-container">
                                          {
                                            hotel['title'].length > 0 && (
                                              <div className="map-hotel-item-title">
                                                {hotel['title']}
                                              </div>
                                            )
                                          }
                                          {
                                            Object.keys(hotel['address']).length > 0 &&
                                            hotel['address']['address'].length > 0 && (
                                              <div className="map-hotel-item-address">
                                                {hotel['address']['address']}
                                              </div>
                                            )
                                          }
                                          {
                                            hotel['location_distance'].length > 0 && (
                                              <div className="map-hotel-item-location-distance">
                                                <img src={window.Rydges['assetsPath'] + 'images/icons/pin-3-grey.svg'}
                                                     width={20}
                                                />
                                                {hotel['location_distance']}
                                              </div>
                                            )
                                          }
                                          {
                                            hotel['book_link'].length > 0 && (
                                              <div className="map-hotel-item-button-wrapper">
                                                <a href={hotel['book_link']}
                                                   className="btn btn-red text-uppercase"
                                                   onClick={(e) => e.stopPropagation()}
                                                >
                                                  Book Now
                                                </a>
                                              </div>
                                            )
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              }
                            </div>
                          </div>
                        )
                      }
                      <div id="hotels-map-wrapper" className="map-wrapper" />
                    </div>
                  )
                }
                {
                  (loading || loadMoreLoading) && (
                    <MapSkeleton />
                  )
                }
              </React.Fragment>
            )
          }
        </div>
      </React.Fragment>
    );
  }
}

AppHotels.propTypes = {
  corporateDiscountText: PropTypes.string,
  flipOnHotelNameClick: PropTypes.bool,
  mapMarkers: PropTypes.shape({
    default: PropTypes.string,
    active: PropTypes.string,
    searched_location: PropTypes.string,
    clustered_locations: PropTypes.string,
  }),
};

AppHotels.defaultProps = {
  corporateDiscountText: '',
  flipOnHotelNameClick: false,
  mapMarkers: {
    default: '',
    active: '',
    searched_location: '',
    clustered_locations: '',
  },
};

const hotelsResults = () => {
  jQuery(document).ready(function($) {
    // Render results
    const resultsWrapper = $('#search-hotels-results-wrapper');
    if (resultsWrapper.length) {
      const dataset = resultsWrapper[0].dataset;

      const resultsProps = {
        corporateDiscountText: dataset.corporateDiscountText || '',
        flipOnHotelNameClick: dataset.flipOnHotelNameClick === 'true',
        mapMarkers: dataset.mapMarkers ? JSON.parse(dataset.mapMarkers) : {},
      };

      ReactDOM.render(<AppHotels {...resultsProps} />, resultsWrapper[0]);
    }

    const hotelViewTypes = $('#hotel-view-types');
    if (hotelViewTypes.length) {
      const viewTypeItem = hotelViewTypes.find('.view-type-item');

      viewTypeItem.on('click', function(e) {
        e.preventDefault();

        const _this = $(this);
        const view = _this.data('view');

        viewTypeItem.removeClass('active');
        _this.addClass('active');

        $(document).trigger(constants.EVENT_VIEW_TYPE_CHANGED, [view]);
      });
    }
  });
};

export default hotelsResults;



// WEBPACK FOOTER //
// ./scripts/routes/modules/hotelsResults.js